class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.startAutoClose();

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  startAutoClose() {
    clearTimeout(this.autoCloseTimer);
    if (!this.autoClosePauseBound) {
      this.autoClosePauseBound = true;
      this.notification.addEventListener('mouseenter', () => clearTimeout(this.autoCloseTimer));
      this.notification.addEventListener('mouseleave', () => this.startAutoClose());
    }
    this.autoCloseTimer = setTimeout(() => {
      if (this.notification.classList.contains('active')) this.close();
    }, 4000);
  }

  close() {
    clearTimeout(this.autoCloseTimer);
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      if (!sectionElement || !parsedState.sections?.[section.id]) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
    this.refreshCartIcon();
  }

  refreshCartIcon() {
    const rootUrl = window.Shopify?.routes?.root || '/';
    fetch(`${rootUrl}?sections=cart-icon-bubble`)
      .then((response) => response.json())
      .then((sections) => {
        const icon = document.getElementById('cart-icon-bubble');
        if (!icon || !sections['cart-icon-bubble']) return;
        icon.innerHTML = this.getSectionInnerHTML(sections['cart-icon-bubble']);
        icon.classList.remove('tnws-cart-bump');
        void icon.offsetWidth;
        icon.classList.add('tnws-cart-bump');
        setTimeout(() => icon.classList.remove('tnws-cart-bump'), 900);
      })
      .catch(() => {});
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const node = doc.querySelector(selector) || doc.body.firstElementChild || doc.body;
    return node ? node.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
